(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-navigation"]) return;
  try {
    
if (!customElements.get('pulse-navigation')) {
  customElements.define('pulse-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-menu-open]');
        if (opener && !this.dialog.open) {
          this.opener = opener;
          this.querySelectorAll('[data-menu-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
          this.dialog.showModal();
        }
        if (event.target.closest('[data-menu-close]')) this.dialog.close();
        if (event.target.closest('a') && this.dialog.open) this.dialog.close();
        if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        this.querySelectorAll('[data-menu-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
        this.opener?.focus();
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        const height = this.querySelector('header').getBoundingClientRect().height;
        document.body.style.setProperty('--header-height', `${height}px`);
        document.body.style.setProperty('--header-group-height', `${height}px`);
      });
      this.resizeObserver.observe(this.querySelector('header'));
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.resizeObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-press-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pulse-press-marquee')) {
  customElements.define('pulse-press-marquee', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-press-viewport]');
      this.group = this.querySelector('[data-press-group]');
      this.toggle = this.querySelector('[data-press-toggle]');
      if (!this.viewport || !this.group || !this.toggle) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reducedMotion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.position = this.viewport.scrollLeft;
      this.speed = Number(this.dataset.speed) || 35;
      this.measure();
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.update(); }, options);
      this.querySelectorAll('[data-press-direction]').forEach(button => {
        button.addEventListener('click', () => {
          this.paused = true;
          this.update();
          const cards = this.group.children;
          const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
          if (!this.loopWidth) return;
          const left = (this.viewport.scrollLeft + Number(button.dataset.pressDirection) * step + this.loopWidth) % this.loopWidth;
          this.viewport.scrollTo({ left, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
        }, options);
      });
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.update(); } }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.update(); }, options);
      this.viewport.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') { this.paused = true; this.update(); } }, options);
      this.viewport.addEventListener('focusin', () => { this.focused = true; this.update(); }, options);
      this.viewport.addEventListener('focusout', () => queueMicrotask(() => { this.focused = this.viewport.contains(document.activeElement); this.update(); }), options);
      this.viewport.addEventListener('scroll', () => { if (!this.running) this.position = this.viewport.scrollLeft; }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.update(), options);
      this.reducedMotion.addEventListener('change', event => { if (event.matches) this.paused = true; this.update(); }, options);
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.group);
      this.intersectionObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); });
      this.intersectionObserver.observe(this);
      this.update();
    }
    measure() {
      this.loopWidth = this.group.getBoundingClientRect().width;
      if (this.loopWidth && this.position >= this.loopWidth) this.position %= this.loopWidth;
    }
    update() {
      this.toggle.setAttribute('aria-pressed', String(this.paused));
      this.querySelector('[data-press-toggle-label]').textContent = this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
      const running = this.visible && !this.paused && !this.hovered && !this.focused && !document.hidden && !window.Shopify?.designMode;
      if (running && !this.running) {
        this.position = this.viewport.scrollLeft;
        this.lastTime = 0;
        this.frame = requestAnimationFrame(time => this.tick(time));
      } else if (!running) {
        cancelAnimationFrame(this.frame);
      }
      this.running = running;
    }
    tick(time) {
      if (!this.running || !this.isConnected) return;
      const elapsed = this.lastTime ? Math.min(time - this.lastTime, 64) : 0;
      this.lastTime = time;
      if (this.loopWidth) {
        this.position = (this.position + elapsed * this.speed / 1000) % this.loopWidth;
        this.viewport.scrollLeft = this.position;
      }
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    disconnectedCallback() {
      this.running = false;
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-product-detail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pulse-product-detail')) {
  customElements.define('pulse-product-detail', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('.pulse-measure');
      this.galleryButtons = [...this.querySelectorAll('[data-gallery-thumbnail]')];
      this.selectImage(0);
      const stage = this.querySelector('.pulse-gallery__stage');
      stage.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') this.swipeStart = { x: event.clientX, y: event.clientY };
      }, { ...options, passive: true });
      stage.addEventListener('pointerup', event => {
        if (!this.swipeStart) return;
        const x = event.clientX - this.swipeStart.x;
        const y = event.clientY - this.swipeStart.y;
        this.swipeStart = null;
        if (Math.abs(x) > 40 && Math.abs(x) > Math.abs(y) * 1.3) this.selectImage(this.galleryIndex + (x < 0 ? 1 : -1));
      }, { ...options, passive: true });
      stage.addEventListener('pointercancel', () => this.swipeStart = null, options);
      this.addEventListener('click', (event) => {
        const target = event.target.closest('button');
        if (!target || !this.contains(target)) return;
        if (target.hasAttribute('data-gallery-thumbnail')) {
          this.selectImage(Number(target.dataset.galleryThumbnail));
        }
        if (target.hasAttribute('data-gallery-prev')) this.selectImage(this.galleryIndex - 1);
        if (target.hasAttribute('data-gallery-next')) this.selectImage(this.galleryIndex + 1);
        if (target.hasAttribute('data-measure-open') && this.dialog && !this.dialog.open) {
          this.opener = target;
          this.dialog.showModal();
        }
        if (target.hasAttribute('data-measure-close')) this.dialog?.close();
        if (target.hasAttribute('data-measure-calculate')) this.calculateSize();
      }, options);
      this.addEventListener('change', (event) => {
        const input = event.target;
        if (!input.matches('[data-size-option]') || !input.checked) return;
        const variantInput = this.querySelector('[data-variant-input]');
        if (input.dataset.variantId) {
          if (variantInput) variantInput.value = input.dataset.variantId;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', input.dataset.variantId);
          window.history.replaceState({}, '', url);
        }
        if (input.dataset.price) {
          this.querySelector('[data-current-price]').textContent = input.dataset.price;
          const compare = this.querySelector('.pulse-price__compare');
          compare.querySelector('[data-compare-price]').textContent = input.dataset.comparePrice;
          compare.hidden = !input.dataset.comparePrice;
          const saving = this.querySelector('[data-price-saving]');
          saving.textContent = input.dataset.saving;
          saving.hidden = !input.dataset.saving;
        }
        const button = this.querySelector('[data-buy-button]');
        if (button) {
          const available = input.dataset.available === 'true';
          button.disabled = !available;
          button.querySelector('[data-buy-label]').textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
        }
      }, options);
      if (this.dialog) {
        this.dialog.addEventListener('close', () => this.opener?.focus(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
      }
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
    selectImage(index) {
      this.galleryIndex = Math.max(0, Math.min(this.galleryButtons.length - 1, index));
      this.querySelectorAll('[data-gallery-panel]').forEach(panel => panel.hidden = Number(panel.dataset.galleryPanel) !== this.galleryIndex);
      this.galleryButtons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.galleryThumbnail) === this.galleryIndex)));
      const counter = this.querySelector('[data-gallery-count]');
      if (counter) counter.textContent = `${String(this.galleryIndex + 1).padStart(2, '0')} / ${String(this.galleryButtons.length).padStart(2, '0')}`;
      this.querySelector('[data-gallery-prev]').disabled = this.galleryIndex === 0;
      this.querySelector('[data-gallery-next]').disabled = this.galleryIndex === this.galleryButtons.length - 1;
    }
    calculateSize() {
      const inputs = [...this.querySelectorAll('[data-measure-input]')];
      for (const input of inputs) if (!input.reportValidity()) return;
      const values = Object.fromEntries(inputs.map(input => [input.dataset.measureInput, Number(input.value)]));
      const matches = [...this.querySelectorAll('[data-measure-size]')].filter(row => {
        const chart = row.dataset;
        return values.height >= Number(chart.heightMin) && values.height <= Number(chart.heightMax)
          && values.leg >= Number(chart.legMin) && values.leg <= Number(chart.legMax)
          && values.thigh <= Number(chart.thighMax);
      }).map(row => row.dataset.measureSize);
      const result = this.querySelector('[data-measure-result]');
      result.textContent = matches.length ? `${result.dataset.matchLabel} ${matches.join(' / ')}` : result.dataset.noMatchLabel;
      result.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-welcome"]) return;
  try {
    
if (!customElements.get('pulse-welcome')) {
  customElements.define('pulse-welcome', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.dataset.designMode === 'true') return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      let seen = false;
      try { seen = Boolean(sessionStorage.getItem('pulse-welcome-v1')); } catch {}
      this.addEventListener('click', (event) => {
        const close = event.target.closest('[data-welcome-close]');
        const choice = event.target.closest('[data-welcome-choice]');
        if (close || choice) {
          try { sessionStorage.setItem('pulse-welcome-v1', choice?.dataset.welcomeChoice || 'dismissed'); } catch {}
          this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        try { sessionStorage.setItem('pulse-welcome-v1', 'dismissed'); } catch {}
        if (this.opener instanceof HTMLElement && this.opener !== document.body) this.opener.focus();
        else document.querySelector('#MainContent a, #MainContent button')?.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      if (!seen && !document.querySelector('dialog[open]')) {
        this.opener = document.activeElement;
        this.dialog.showModal();
      }
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
